// PrimeUI Commercial license key (ARP-7817). PrimeNG 22 moved to the commercial
// PrimeUI License; this key suppresses the invalid-license notice and keeps us compliant.
// It is verified offline via digital signature, contains no sensitive data, and is safe to
// ship in the app bundle. Kept in one place so renewals only touch this file.
//
// Decoded payload: tier=commercial, EXPIRES 2027-07-21 (exp 1816196526). After that date
// the license notice reappears for users — track renewal against ARP-7817.
export const PRIMEUI_LICENSE_KEY =
  'eyJpZCI6IjE1ZjcyNTlkLTg3NDctNDBlZC1hNzc5LTBhMjhlYmM4NDRlZiIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW1lcmNpYWwiLCJ0eXBlIjoiZGV2IiwiaWF0IjoxNzg0NjYxMTM5LCJleHAiOjE4MTYxOTY1MjZ9.NDBg1kCC2yqxXQ_kic4tbeif3shJCogZTsOON2qZBM3G7zuCEvD2NbaF9Etse4WC7D8nrBIYpisiWA0GkBOVDQ'
